<div class="ai-assistant" #assistantRoot aria-live="polite"
    [class.ai-assistant--positioned]="positionReady"
    [class.ai-assistant--dragging]="isDragging"
    [style.transform]="containerTransform">
    @if (ai.showTeaser()) {
    <div class="ai-assistant__teaser" role="status">
        <button type="button" class="ai-assistant__teaser-body" (click)="onTeaserClick()"
            [attr.aria-label]="'Mở ' + name">
            <span class="ai-assistant__teaser-glow" aria-hidden="true"></span>
            <span class="ai-assistant__status-dot ai-assistant__status-dot--pulse" aria-hidden="true"></span>
            <span class="ai-assistant__teaser-text">
                <strong>{{ name }}</strong>
                <span class="ai-assistant__teaser-hint">Cần hỗ trợ vận hành?</span>
            </span>
            <i class="fa-solid fa-arrow-right ai-assistant__teaser-arrow" aria-hidden="true"></i>
        </button>
        <button type="button" class="ai-assistant__teaser-close" (click)="onDismissTeaser()"
            aria-label="Đóng thông báo">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
    </div>
    }

    @if (ai.panelOpen()) {
    <section class="ai-assistant__panel" role="dialog" aria-modal="false" [attr.aria-label]="name">
        <div class="ai-assistant__panel-backdrop" aria-hidden="true">
            <span class="ai-assistant__panel-orb ai-assistant__panel-orb--1"></span>
            <span class="ai-assistant__panel-orb ai-assistant__panel-orb--2"></span>
            <span class="ai-assistant__panel-grid"></span>
        </div>

        <header class="ai-assistant__header">
            <div class="ai-assistant__header-glow" aria-hidden="true"></div>
            <div class="ai-assistant__header-main">
                <div class="ai-assistant__header-avatar-ring">
                    <img class="ai-assistant__brand-img ai-assistant__brand-img--header" [src]="brandImage"
                        alt="Logistics Technology Application" />
                </div>
                <div class="ai-assistant__header-text">
                    <div class="ai-assistant__header-title-row">
                        <h2 class="ai-assistant__title">{{ name }}</h2>
                        <span class="ai-assistant__badge-live">
                            <i class="fa-solid fa-sparkles" aria-hidden="true"></i>
                            <span class="ai-assistant__status-dot ai-assistant__status-dot--pulse"
                                aria-hidden="true"></span>
                            AI · 24/7
                        </span>
                    </div>
                    <p class="ai-assistant__subtitle">{{ subtitle }}</p>
                </div>
            </div>
            <div class="ai-assistant__header-actions">
                <button type="button" class="ai-assistant__icon-btn" (click)="onRefresh()"
                    aria-label="Làm mới hội thoại">
                    <i class="fa-solid fa-rotate-right" aria-hidden="true"></i>
                </button>
                <button type="button" class="ai-assistant__icon-btn" (click)="ai.minimizePanel()"
                    aria-label="Thu gọn">
                    <i class="fa-solid fa-minus" aria-hidden="true"></i>
                </button>
                <button type="button" class="ai-assistant__icon-btn" (click)="ai.closePanel()" aria-label="Đóng">
                    <i class="fa-solid fa-xmark" aria-hidden="true"></i>
                </button>
            </div>
        </header>

        <div class="ai-assistant__panel-body">
            <div class="ai-assistant__suggestions"
                [class.ai-assistant__suggestions--collapsed]="!suggestionsExpanded">
                <button type="button" class="ai-assistant__suggestions-toggle" (click)="toggleSuggestions()"
                    [attr.aria-expanded]="suggestionsExpanded" aria-controls="ai-assistant-suggestions-chips"
                    [attr.aria-label]="suggestionsExpanded ? 'Thu gọn gợi ý nhanh' : (hiddenSuggestionCount() ? 'Mở thêm gợi ý nhanh' : 'Mở gợi ý nhanh')">
                    <span class="ai-assistant__suggestions-icon" aria-hidden="true">
                        <i class="fa-solid fa-wand-magic-sparkles"></i>
                    </span>
                    <span class="ai-assistant__suggestions-label">Gợi ý nhanh</span>
                    <span class="ai-assistant__suggestions-count">{{ ai.suggestions().length }}</span>
                    <i class="fa-solid fa-chevron-down ai-assistant__suggestions-chevron"
                        [class.ai-assistant__suggestions-chevron--open]="suggestionsExpanded" aria-hidden="true"></i>
                </button>
                @if (visibleSuggestions().length) {
                <div id="ai-assistant-suggestions-chips" class="ai-assistant__chips"
                    [class.ai-assistant__chips--preview]="!suggestionsExpanded" role="list">
                    @for (chip of visibleSuggestions(); track chip.id) {
                    <button type="button" class="ai-assistant__chip" role="listitem"
                        (click)="onSuggestionClick(chip.prompt)">
                        @if (chip.icon) {
                        <span class="ai-assistant__chip-icon" aria-hidden="true">
                            <i class="fa-solid {{ chip.icon }}"></i>
                        </span>
                        }
                        <span>{{ chip.label }}</span>
                    </button>
                    }
                    @if (!suggestionsExpanded && hiddenSuggestionCount() > 0) {
                    <button type="button" class="ai-assistant__chip ai-assistant__chip--more"
                        (click)="toggleSuggestions()" aria-label="Mở thêm gợi ý nhanh">
                        +{{ hiddenSuggestionCount() }}
                    </button>
                    }
                </div>
                }
            </div>

            <div class="ai-assistant__messages" #messageList role="log" aria-label="Hội thoại">
            @for (msg of ai.messages(); track msg.id) {
            <div class="ai-assistant__message" [class.ai-assistant__message--user]="msg.role === 'user'"
                [class.ai-assistant__message--assistant]="msg.role === 'assistant'">
                @if (msg.role === 'assistant') {
                <div class="ai-assistant__avatar-ring" aria-hidden="true">
                    <img class="ai-assistant__brand-img ai-assistant__brand-img--bubble" [src]="brandImage" alt="" />
                </div>
                }
                <div class="ai-assistant__message-body">
                    <div class="ai-assistant__bubble" [class.ai-assistant__bubble--user]="msg.role === 'user'"
                        [class.ai-assistant__bubble--assistant]="msg.role === 'assistant'">
                        <div class="ai-assistant__bubble-text" [innerHTML]="formatMessage(msg.text)"></div>
                    </div>
                    @if (msg.role === 'assistant' && msg.related?.length) {
                    <div class="ai-assistant__related">
                        <span class="ai-assistant__related-label">
                            <i class="fa-solid fa-bolt" aria-hidden="true"></i>
                            Tiếp theo
                        </span>
                        <div class="ai-assistant__related-chips">
                            @for (chip of msg.related; track chip.id) {
                            <button type="button" class="ai-assistant__related-chip"
                                (click)="onSuggestionClick(chip.prompt)" [disabled]="ai.isTyping()">
                                <span>{{ chip.label }}</span>
                                <i class="fa-solid fa-arrow-right" aria-hidden="true"></i>
                            </button>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            }
            @if (ai.isTyping()) {
            <div class="ai-assistant__message ai-assistant__message--assistant">
                <div class="ai-assistant__avatar-ring" aria-hidden="true">
                    <img class="ai-assistant__brand-img ai-assistant__brand-img--bubble" [src]="brandImage" alt="" />
                </div>
                <div class="ai-assistant__message-body">
                    <div class="ai-assistant__bubble ai-assistant__bubble--assistant ai-assistant__bubble--typing">
                        <span class="ai-assistant__typing-label">Đang phân tích</span>
                        <span class="ai-assistant__typing-dots">
                            <span class="ai-assistant__typing-dot"></span>
                            <span class="ai-assistant__typing-dot"></span>
                            <span class="ai-assistant__typing-dot"></span>
                        </span>
                    </div>
                </div>
            </div>
            }
            </div>

            <footer class="ai-assistant__footer">
                <div class="ai-assistant__input-shell">
                    <div class="ai-assistant__input-row">
                        <span class="ai-assistant__input-prefix" aria-hidden="true">
                            <i class="fa-solid fa-message"></i>
                        </span>
                        <input #inputField type="text" class="ai-assistant__input" [(ngModel)]="inputText"
                            placeholder="Hỏi về chuyến xe, điều phối, giám sát…" (keydown.enter)="onSend()"
                            [attr.aria-label]="'Nhập câu hỏi cho ' + name" />
                        <button type="button" class="ai-assistant__send" (click)="onSend()"
                            [disabled]="!inputText.trim() || ai.isTyping()" aria-label="Gửi">
                            <i class="fa-solid fa-paper-plane" aria-hidden="true"></i>
                        </button>
                    </div>
                </div>
                <div class="ai-assistant__footer-meta">
                    <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                    <span>Logistics Technology Application</span>
                </div>
            </footer>
        </div>
    </section>
    }

    <button type="button" class="ai-assistant__fab" #fabButton
        (pointerdown)="onFabPointerDown($event)"
        [class.ai-assistant__fab--open]="ai.panelOpen()" [attr.aria-label]="name"
        [attr.aria-expanded]="ai.panelOpen()">
        @if (ai.panelOpen()) {
        <span class="ai-assistant__fab-ring" aria-hidden="true"></span>
        <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
        } @else {
        <span class="ai-assistant__fab-ring" aria-hidden="true"></span>
        <img class="ai-assistant__brand-img ai-assistant__brand-img--fab" [src]="brandImage"
            alt="Trợ lý AI I-TMS" />
        }
    </button>
</div>
